var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BjPage", {
        ref: "BjPage",
        attrs: {
          "label-width": "80px",
          "query-params": _vm.queryParams,
          "col-span": _vm.colSpan,
          "get-action": _vm.queryApi,
          serial: false,
        },
        on: {
          showSetting: _vm.SortableTable.show,
          "header-dragend": _vm.SortableTable.handleHeaderDragend,
          "header-contextmenu": _vm.SortableTable.handleHeaderContextmenu,
        },
        scopedSlots: _vm._u([
          {
            key: "baseForm",
            fn: function () {
              return undefined
            },
            proxy: true,
          },
          {
            key: "tableOperation",
            fn: function () {
              return [
                _c(
                  "el-col",
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "main-btn",
                        attrs: { type: "primary" },
                        on: { click: _vm.onAdd },
                      },
                      [_vm._v(_vm._s(_vm.$t("billingPage.create")))]
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableColumn",
            fn: function () {
              return [
                _vm._l(_vm.dropCols, function (col, index) {
                  return [
                    col.prop !== "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || false,
                            align: "center",
                            "class-name": "item",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    false
                                      ? void 0
                                      : col.prop === "profitMarginFrom"
                                      ? [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                scope.row.profitMarginFrom +
                                                  "% <= Margin < " +
                                                  scope.row.profitMarginTo +
                                                  "%"
                                              )
                                          ),
                                        ]
                                      : col.prop === "salesTurnoverFrom"
                                      ? [
                                          _vm._v(
                                            _vm._s(
                                              scope.row.salesTurnoverFrom +
                                                " <= Turnover < " +
                                                scope.row.salesTurnoverTo
                                            )
                                          ),
                                        ]
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("timeFilters")(
                                                scope.row[col.prop],
                                                scope.row[col.prop]
                                              )
                                            )
                                          ),
                                        ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                    col.prop === "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || "right",
                            align: "center",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (props) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "edit-btn",
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onEdit(props.row)
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.$t("editText")))]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "delete-btn",
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onDelete(props.row)
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.$t("delText")))]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                  ]
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c(
        "el-dialog",
        {
          attrs: { title: "", visible: _vm.dialogFormVisible, width: "450px" },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-position": "top",
              },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "tierName",
                    label: _vm.$t("billingPage.tierName"),
                  },
                },
                [
                  _c("BjInput", {
                    staticStyle: { width: "400px" },
                    model: {
                      value: _vm.form.tierName,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "tierName", $$v)
                      },
                      expression: "form.tierName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "profitMarginTo",
                    label: _vm.$t("billingPage.ProfitMargin"),
                  },
                },
                [
                  _c(
                    "el-row",
                    { staticClass: "flex-align" },
                    [
                      _c(
                        "el-input",
                        {
                          staticStyle: { width: "140px" },
                          attrs: {
                            controls: false,
                            placeholder: _vm.$t("inputText"),
                            onkeyup:
                              "this.value = this.value.replace(/[^\\d.-]/g,'');",
                          },
                          model: {
                            value: _vm.form.profitMarginFrom,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "profitMarginFrom", $$v)
                            },
                            expression: "form.profitMarginFrom",
                          },
                        },
                        [_c("template", { slot: "append" }, [_vm._v("%")])],
                        2
                      ),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            width: "120px",
                            "text-align": "center",
                          },
                        },
                        [_vm._v(_vm._s("<= Margin <") + " ")]
                      ),
                      _c(
                        "el-input",
                        {
                          staticStyle: { width: "140px" },
                          attrs: {
                            controls: false,
                            placeholder: _vm.$t("inputText"),
                            onkeyup:
                              "this.value = this.value.replace(/[^\\d.-]/g,'');",
                          },
                          model: {
                            value: _vm.form.profitMarginTo,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "profitMarginTo", $$v)
                            },
                            expression: "form.profitMarginTo",
                          },
                        },
                        [_c("template", { slot: "append" }, [_vm._v("%")])],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "salesTurnoverTo",
                    label: _vm.$t("billingPage.salesTurnoverFrom"),
                  },
                },
                [
                  _c(
                    "el-row",
                    { staticClass: "flex-align" },
                    [
                      _c("BjInputMoney", {
                        staticStyle: { width: "140px" },
                        attrs: { min: 0 },
                        model: {
                          value: _vm.form.salesTurnoverFrom,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "salesTurnoverFrom", $$v)
                          },
                          expression: "form.salesTurnoverFrom",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            width: "120px",
                            "text-align": "center",
                          },
                        },
                        [_vm._v(_vm._s("<= Turnover <"))]
                      ),
                      _vm._v(" "),
                      _c("BjInputMoney", {
                        staticStyle: { width: "140px" },
                        attrs: { min: 0 },
                        model: {
                          value: _vm.form.salesTurnoverTo,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "salesTurnoverTo", $$v)
                          },
                          expression: "form.salesTurnoverTo",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: { prop: "tierName", label: _vm.$t("table.countText") },
                },
                [
                  _c("BjInputNumber", {
                    staticStyle: { width: "400px" },
                    model: {
                      value: _vm.form.sortNo,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "sortNo", $$v)
                      },
                      expression: "form.sortNo",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogFormVisible = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("cancelText")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.comfirm()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("okText")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }